import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { toast } from "sonner";
import { initNative } from "@/lib/native";

// Globally silence all "success" / "info" toasts (loud per-action confirmations
// the user explicitly asked to remove). Errors stay visible.
toast.success = () => {};
toast.info = () => {};
toast.message = () => {};

// Capacitor native bootstrap — no-op on web, registers push +
// configures status bar/splash inside the iOS/Android wrapper.
initNative().catch(() => {});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
